<template>
  <SfInput
    v-focus
    class="sf-search-bar"
    autocomplete="off"
    type="search"
    name="search"
    :value="value"
    :placeholder="placeholder"
    :icon="icon"
    v-bind="$attrs"
    v-on="listeners"
    @keyup.enter="$emit('input', value)"
  >
    <template #icon>
      <slot
        name="icon"
        v-bind="{ icon }"
      />
    </template>
  </SfInput>
</template>
<script>
import SfInput from '~/node_modules/@storefront-ui/vue/src/components/atoms/SfInput/SfInput.vue';
import { focus } from '~/node_modules/@storefront-ui/vue/src/utilities/directives';

export default {
  name: 'SfSearchBar',
  components: { SfInput },
  directives: {
    focus,
  },
  inheritAttrs: false,
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      default: null,
    },
    icon: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        'keyup.esc': () => this.$emit('input', ''),
        blur: () => this.$emit('blur'),
        'click:icon': () => this.$emit('click:icon', this.value),
      };
    },
  },
};
</script>
<style lang="scss">
@import "assets/css/my-mixins.scss";
@import "~@storefront-ui/shared/styles/components/molecules/SfSearchBar.scss";

.sf-search-bar {
  .sf-input__wrapper {
    input {
      background-color: var(--color-light-hot-grey);
    }
  }
}
</style>
